export default __webpack_public_path__ + "static/media/logo.fd529938.svg";